import { Link } from 'react-router-dom';
import { AuthLayout } from '@/components/auth-layout';

export function NotFoundPage() {
  return (
    <AuthLayout
      title="Page not found"
      description="That page doesn't exist, or you no longer have access to it."
      footer={
        <Link to="/sign-in" className="font-medium text-brand-400 hover:text-brand-300">
          Go to sign in
        </Link>
      }
    >
      <p className="text-sm text-slate-400">
        If you followed a link from a MindPeer module, try opening the module again.
      </p>
    </AuthLayout>
  );
}
